import { useEffect, useMemo, useState } from 'react';
import { debounce } from 'marketplace-ui-common/utils/debounce';
import { useFetchAiSettingsAccess } from 'marketplace-ui-common/hooks/useFetchAiSettingsAccess';
import { useGenerateTitleQuery } from '../../__generated__/chirp/com/hubspot/reviews/rpc/ReviewsRpc.hooks';
export function useGeneratedReviewTitle({
  answers,
  ratings,
  entityName,
  reviewType
}) {
  const [formattedAnswers, setFormattedAnswers] = useState(() => {
    const answersWithoutTitle = structuredClone(answers);
    delete answersWithoutTitle.TITLE;
    return answersWithoutTitle;
  });
  const [formattedRatings, setFormattedRatings] = useState(structuredClone(ratings));
  const hasContent = !Object.values(formattedAnswers).every(value => !value);
  const [skip, setSkip] = useState(!hasContent);
  const {
    generativeAiEnabled
  } = useFetchAiSettingsAccess();
  const {
    data,
    error,
    loading
  } = useGenerateTitleQuery({
    variables: {
      answers: formattedAnswers,
      ratings: formattedRatings,
      entityName,
      // @ts-expect-error Asset review type not yet supported
      type: reviewType
    },
    skip: !generativeAiEnabled || skip,
    timeout: 30000
  });
  const debouncedUpdate = useMemo(() => debounce((newAnswers, newRatings) => {
    const answersWithoutTitle = structuredClone(newAnswers);
    delete answersWithoutTitle.TITLE;
    setFormattedAnswers(answersWithoutTitle);
    setFormattedRatings(structuredClone(newRatings));
    const hasNewContent = !Object.values(answersWithoutTitle).every(value => !value);
    setSkip(!hasNewContent);
  }, 300), []);

  // Update when answers or ratings change
  useEffect(() => {
    debouncedUpdate(answers, ratings);
  }, [answers, ratings, debouncedUpdate]);
  return {
    generativeAiEnabled,
    generatedTitle: data && !error ? data.title : undefined,
    loading
  };
}